import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { InfoIcon } from '@phosphor-icons/react';
import { ActionType } from '../utils/types.ts';
import { CTAIcon } from './CTAIcon.tsx';
import { actionSx, iconContainerSx, rootSx } from './styles.ts';

export type CallToActionProps = {
  actionType: ActionType;
  text: string;
  tooltip?: string;
  onClick?: () => void;
  disabled?: boolean;
};

export const CallToAction = ({ actionType, tooltip, text, onClick, disabled = false }: CallToActionProps) => {
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;
  const disabledColor = theme.palette.action.disabled;

  return (
    <Box sx={rootSx(disabled, onClick !== undefined)}>
      <ButtonBase disabled={disabled || !onClick} onClick={onClick} sx={actionSx}>
        <Box sx={iconContainerSx}>{actionType !== ActionType.EMPTY && <CTAIcon actionType={actionType} />}</Box>
        <Typography component="div">{text}</Typography>
      </ButtonBase>

      {!!tooltip && (
        <Tooltip title={tooltip}>
          <IconButton
            disabled={disabled}
            sx={{ p: 0, minWidth: 36, minHeight: 36 }}
            onClick={event => event.stopPropagation()}
          >
            <InfoIcon color={disabled ? disabledColor : primaryColor} size={18} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
